var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal fade", attrs: { id: "myModal", role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _c("label", [_vm._v(_vm._s(_vm.eventDetails.class_name))])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-6 col-sm-6 col-md-6 col-lg-6" },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("Class Type")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.capitalizeFirstLetter(
                                  _vm.eventDetails.class_type
                                )
                              )
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.eventDetails.doc_path != null &&
                    _vm.eventDetails.doc_path != ""
                      ? [
                          _c(
                            "div",
                            { staticClass: "col-6 col-sm-6 col-md-6 col-lg-6" },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label"),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.eventDetails.doc_path,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        height: "100px",
                                        width: "100px"
                                      },
                                      attrs: { src: _vm.eventDetails.doc_path }
                                    })
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.eventDetails.class_type === "recurring" &&
                _vm.eventDetails.recurring_type === "weekly"
                  ? [
                      _c(
                        "div",
                        { staticClass: "col-6 col-sm-6 col-md-6 col-lg-6" },
                        [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Day Of Week")]
                            ),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(_vm.eventDetails.week_day))])
                          ])
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.eventDetails.class_type === "normal" ||
                (_vm.eventDetails.class_type == "recurring" &&
                  _vm.eventDetails.recurring_type == "monthly") ||
                (_vm.eventDetails.class_type == "recurring" &&
                  _vm.eventDetails.recurring_type == "yearly")
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 forms-block d-flex justify-content-between"
                        },
                        [
                          _c("div", { staticClass: "col-4" }, [
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-label",
                                  staticStyle: { "font-weight": "bold" },
                                  attrs: { slot: "before", for: "startDate" },
                                  slot: "before"
                                },
                                [_vm._v("Date :")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c("p", [
                                _vm._v(_vm._s(_vm.eventDetails.start_date))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4" }, [
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-label",
                                  staticStyle: { "font-weight": "bold" },
                                  attrs: { slot: "before", for: "startTime" },
                                  slot: "before"
                                },
                                [_vm._v("Start Time :")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c("p", [
                                _vm._v(_vm._s(_vm.eventDetails.start_time))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4" }, [
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-label",
                                  staticStyle: { "font-weight": "bold" },
                                  attrs: { slot: "before", for: "endTime" },
                                  slot: "before"
                                },
                                [_vm._v("End Time :")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c("p", [
                                _vm._v(_vm._s(_vm.eventDetails.end_time))
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.eventDetails.class_type == "multipledate"
                  ? [
                      _vm._l(_vm.eventDetails.inputs, function(input, index) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 forms-block d-flex justify-content-between"
                            },
                            [
                              _c("div", { staticClass: "col-4" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 paddingleft0" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-label",
                                        staticStyle: { "font-weight": "bold" },
                                        attrs: {
                                          slot: "before",
                                          for: "endTime"
                                        },
                                        slot: "before"
                                      },
                                      [_vm._v("Date")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-12 paddingleft0" },
                                  [_c("p", [_vm._v(_vm._s(input.startDate))])]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 paddingleft0" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-label",
                                        staticStyle: { "font-weight": "bold" },
                                        attrs: {
                                          slot: "before",
                                          for: "endTime"
                                        },
                                        slot: "before"
                                      },
                                      [_vm._v("Start Time")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-12 paddingleft0" },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(input.startTime.text))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 paddingleft0" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-label",
                                        staticStyle: { "font-weight": "bold" },
                                        attrs: {
                                          slot: "before",
                                          for: "endTime"
                                        },
                                        slot: "before"
                                      },
                                      [_vm._v("End Time")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-12 paddingleft0" },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(input.endTime.text))
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-12 col-md-12 col-lg-12" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("Description")
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.eventDetails.description)
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ],
              2
            ),
            _vm._v(" "),
            _vm.eventDetails.already_register == true &&
            _vm.eventDetails.is_register
              ? [
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-12 col-md-12 col-lg-12" },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "form-control btn-danger",
                            on: {
                              click: function($event) {
                                return _vm.cancelRegistration()
                              }
                            }
                          },
                          [_vm._v("Cancel Registration")]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ]
              : _vm.eventDetails.is_class_full == true
              ? [
                  _c("p", { staticStyle: { color: "red" } }, [
                    _vm._v("Sorry class is full!")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "form-control btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.registerToClass()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "Register ( " +
                          _vm._s(_vm.eventDetails.waiting) +
                          " Waiting )"
                      )
                    ]
                  )
                ]
              : _vm.eventDetails.attented == true
              ? void 0
              : _vm.eventDetails.dependent_class_not_attand == true
              ? [
                  _c("p", { staticStyle: { color: "red" } }, [
                    _vm._v("You are not eligible for this class!")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "You need to attand the " +
                        _vm._s(
                          _vm.eventDetails.dependent_class_not_attand_string
                        ) +
                        " classes."
                    )
                  ])
                ]
              : [
                  _c(
                    "button",
                    {
                      staticClass: "form-control btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.registerToClass()
                        }
                      }
                    },
                    [_vm._v("Register")]
                  )
                ]
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7290851c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7290851c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonModelForClass/CommonModel.vue
// module id = null
// module chunks = 